import type { AppProfile } from "@/lib/appProfile";
import { apiFetch } from "@/lib/apiClient";

async function readJson<T>(response: Response): Promise<T> {
  const payload = (await response.json().catch(() => ({}))) as T & {
    error?: string;
  };

  if (!response.ok) {
    const message =
      typeof payload.error === "string" && payload.error ? payload.error : "Request failed";
    throw new Error(message);
  }

  return payload;
}

export async function getCurrentProfileRecord(): Promise<AppProfile> {
  const response = await apiFetch("/api/profile", { method: "GET" });
  const payload = await readJson<{ profile: AppProfile }>(response);
  return payload.profile;
}

export async function updateCurrentProfile(input: { displayName: string }): Promise<AppProfile> {
  const response = await apiFetch("/api/profile", {
    method: "PATCH",
    body: JSON.stringify({ display_name: input.displayName }),
  });

  const payload = await readJson<{ ok: true; profile: AppProfile | null }>(response);
  if (!payload.profile) {
    throw new Error("Updated profile was not returned");
  }
  return payload.profile;
}

export async function deleteCurrentProfile(input: { confirmation: string }): Promise<void> {
  const response = await apiFetch("/api/profile", {
    method: "DELETE",
    body: JSON.stringify({ confirmation: input.confirmation }),
  });
  await readJson<{ ok: true }>(response);
}
